import { create } from 'zustand';

import type { SnapZone } from './snap';

/**
 * Efemérní stav náhledu edge-snapu během tažení okna. `usePointerDrag` zónu nastavuje (z pozice
 * kurzoru), `PhoenixDesktop` ji čte a vykresluje `.pwm-snap-preview`. Žádná perzistence — jen UI
 * preview. (Zapnutost snapu se čte z `isEdgeSnapEnabled()` při startu dragu, ne odsud.)
 */
interface SnapStoreState {
  readonly zone: SnapZone | null;
  readonly setZone: (zone: SnapZone | null) => void;
}

export const useSnapStore = create<SnapStoreState>((set, get) => ({
  zone: null,
  // Dedupe: stejná hodnota → no-op (ať se náhled zbytečně nepřekresluje při každém pointermove).
  setZone: (zone) => {
    if (get().zone === zone) return;
    set({ zone });
  },
}));
